<template>
	<div class="px-5">
		<app-table
			class="mt-5 is-not-selectable"
			name="roles"
			:columns="columns"
			:current-page="currentPage"
			:last-page="lastPage"
			:rows="rows"
			@on-page="changePage"
			@on-search-event="onSearch"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
					v-show="showRow(columns, 1)"
				>
					{{ props.row.id }}
				</td>
				<td v-show="showRow(columns, 2)">
					{{ props.row.name }}
				</td>
				<td>
					<app-tooltip-button
						color="green"
						icon="edit"
						text="Editar Rol"
						@click-icon="edit(props.row)"
					/>
					<app-tooltip-button
						color="orange"
						icon="control_point_duplicate"
						text="Duplicar Rol"
						@click-icon="duplicate(props.row)"
					/>
					<app-tooltip-button
						color="primary"
						icon="lock_open"
						text="Permisos"
						@click-icon="openAccess(props.row)"
					/>
					<app-tooltip-button
						color="red"
						icon="delete"
						text="Eliminar Rol"
						@click-icon="openModalConfirmation(props.row)"
					/>
				</td>
			</template>
		</app-table>
		<app-confirmation-modal
			:loading="loading"
			:show-modal="modalConfirmation.value"
			@cancel="cancelModalConfirmation"
			@confirm="confirm()"
		/>
	</div>
</template>

<script>
import appTooltipButton from '@/components/shared/app-tooltip-button';
import appConfirmationModal from '@/components/shared/app-confirmation-modal';

function changePage(page) {
	this.$emit('change-page', page);
}

function confirm() {
	this.loading = true;
	this.$http
		.delete(`role/${this.modalConfirmation.selectedRow.id}`)
		.then(() => {
			this.showNotification('Registro eliminado correctamente');
			this.modalConfirmation.value = false;
			this.$emit('on-delete');
		})
		.finally(() => {
			this.loading = false;
		});
}

function duplicate({ id, name }) {
	this.goTo('page-role-duplicate', { params: { id, codeCompany: this.codeCompany, codeProject: this.codeProject, name } });
}

function edit({ id }) {
	this.goTo('page-role-edit', { params: { id, codeCompany: this.codeCompany, codeProject: this.codeProject } });
}

function openAccess({ id, name }) {
	const codeCompany = this.codeCompany;
	const codeProject = this.codeProject;
	this.goTo('page-access-role', { params: { codeCompany, roleId: id, roleName: name, codeProject } });
}

function onSearch(value) {
	this.$emit('on-search', value);
}

function data() {
	return {
		loading: false,
	};
}

export default {
	name: 'role-list',
	components: {
		appConfirmationModal,
		appTooltipButton,
	},
	data,
	props: {
		codeCompany: {
			type: String,
		},
		codeProject: {
			type: String,
		},
		columns: {
			type: Array,
			required: true,
		},
		currentPage: {
			type: Number,
			default: 0,
		},
		lastPage: {
			type: Number,
			default: 0,
		},
		rows: {
			type: Array,
			required: true,
		},
	},
	methods: {
		changePage,
		confirm,
		duplicate,
		edit,
		openAccess,
		onSearch,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/roles/role-list.vue